<div class="modal-body">
    <span>Fakturaer skrives altid i DKK. Valutaen og kursen bestemmer hvordan den dannes til PDF og udskrift.</span>
    <div class="input-group mt-2">
        <select #valuta class="form-select" (change)="onCurrencySelect($event.target.value)" [value]="fakturaValuta?.valuta">
            <option *ngFor="let currency of currencies" [value]="currency.valuta">{{ currency.valuta }}</option>
        </select>
        <input #valutaKurs type="text" class="form-control text-end" [value]="fakturaValuta.valutaKurs | currency:'DKK':'':'1.2-2':'da'">
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-sm btn-danger" (click)="onCancel()">Annuller</button>
    <button type="button" class="btn btn-sm btn-success ms-2" (click)="onCurrencyChange()">Skift valuta</button>
</div>
